import glo from '../../main'
import { tkParse } from '@moke/vue-tk'

export default {
  className: 'roomNumber',
  render: (residentialQuarters) => {
    return `${residentialQuarters.name}`
  },
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '房号不可为空'
      ]
    }
  ],
  hooks: {
    async beforeInsert ({ data }) {
      const { data: res } = await tkParse.get(`/classes/roomNumber`, {
        params: {
          where: {
            name: data.name
          }
        }
      })
      if (res.results.length) {
        throw new Error('房号已存在')
      }
    }
  },
  action: {
    // delete: false,
    download: {
      type: 'list',
      text: '下载模板',
      callback: async function () {
        window.open('https://moke-runji.oss-cn-beijing.aliyuncs.com/88248f07-c649-44de-bb86-d219ad46899c.xlsx', '_blank')
      }
    },
    imports: {
      type: 'list',
      icon: 'import',
      text: '导入',
      callback: async function imports ({ vm }) {
        try {
          const excel = await glo.$excel.pick()
          const exceldata = excel.toJson()
          glo.$loading.show()
          for (let i = 0; i < exceldata.Sheet1.length; i++) {
            const element = exceldata.Sheet1[i]
            // 获取对象的key
            const keys = Object.keys(element)
            // 判断两个数组元素是否相同
            const board = ['房号']
            const isSame = keys.every((item) => board.includes(item))
            if (!isSame) {
              throw new Error()
            }
            const data = element['房号'].toString()
            const res = await tkParse.get(`/classes/roomNumber`, {
              params: {
                where: {
                  name: data
                }
              }
            })
            console.log(res)
            if (res.data.results.length === 0) {
              await tkParse.post(`/classes/roomNumber`, {
                name: data
              })
            } else {
              glo.$loading.hide()
              glo.$notification['error']({
                message: '操作失败',
                description: `第${i + 1}条数据异常`
              })
              if (i > 0) {
                vm.refresh()
              }
              return
            }
          }
          glo.$loading.hide()
          glo.$notification['success']({
            message: '操作成功',
            description: '数据已导入'
          })
          vm.refresh()
        } catch (e) {
          glo.$loading.hide()
          glo.$notification['error']({
            message: '操作失败',
            description: '数据格式错误'
          })
        }
      }
    }
  }
}
